import { createSlice } from "@reduxjs/toolkit"
import { getSessionItem, setSessionItem } from "../../utils/storageUtils"
import { OXE_CLIENT_INFO, TOKEN_2, OXE_UMC_CONNECTED,CC_PRODUCT_ID } from "../../utils/Constants"

export const OxeReducer = createSlice({
    name: 'oxe',
    initialState: {
        oxeUmcConnected: getSessionItem(OXE_UMC_CONNECTED) === "true" ? true : getSessionItem(OXE_UMC_CONNECTED) === "false" ? false : undefined,
        oxeAuthStatus: getSessionItem(TOKEN_2) ? true : false,
        oxeAndClientInfo: JSON.parse(getSessionItem(OXE_CLIENT_INFO)),
        logTableSchema: [],
        logTableList: null,
        logFilteredList: [],
        oxeSystemConfigSchema: [],
        oxeSystemConfigData: [],
        oxeCcProductId : getSessionItem(CC_PRODUCT_ID),
        oxeUmcDiscriminator: [],
    },
    reducers: {
        setOxeUmcConnected: (state, action) => {
            setSessionItem(OXE_UMC_CONNECTED, action.payload)
            state.oxeUmcConnected = action.payload
        },
        setOxeAuthStatus: (state, action) => {
            state.oxeAuthStatus = action.payload
        },
        setOxeAndClientInfo: (state, action) => {
            setSessionItem(OXE_CLIENT_INFO, JSON.stringify(action.payload))
            state.oxeAndClientInfo = action.payload
            state.oxeUmcConnected = true
        },
        setOxeLogSchema: (state, action) => {
            state.logTableSchema = action.payload
        },
        setOxeLogList: (state, action) => {
            state.logTableList = action.payload
            state.logFilteredList = action.payload
        },
        setLogFilteredList: (state, action) => {
            state.logFilteredList = action.payload
        },
        setOxeSystemConfigSchema: (state, action) => {
            state.oxeSystemConfigSchema = action.payload
        },
        setOxeSystemConfigData: (state, action) => {
            state.oxeSystemConfigData = action.payload
        },
        setOxeUmcDiscriminator: (state, action) => {
            state.oxeUmcDiscriminator = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { setOxeUmcConnected, setOxeAuthStatus, setOxeAndClientInfo, setOxeLogSchema,
    setOxeLogList, setLogFilteredList, setOxeSystemConfigSchema, setOxeSystemConfigData, setOxeUmcDiscriminator } = OxeReducer.actions

export default OxeReducer.reducer